var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.buttons && _vm.buttons.length)?_c('span',{class:{ 'm-r-q': !_vm.$viewport.xs }},[_vm._l((_vm.buttons),function(sc,index){return [_c('t-widget',{key:index,class:{ 'm-l-q': !_vm.$viewport.xs },attrs:{"schema":sc,"data":_vm.data}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }